/**
 * http://confluence.mockuai.com/display/wdzgxcx/module_property%23title
 */
let config = [{
        name: "充值记录",
        type: "module-name"
    },
    {
        key: "property_data",
        name: "属性",
        type: "custom",
        content: [{
                key: "icon_url",
                name: "封面图片",
                type: "img",
                memo: "建议尺寸：60px*60px"
            },
            {
                key: "name",
                name: "文案",
                type: "text",
                memo: "文案最多20个汉字",
                max: 20
            }
        ]
    }
];

export default config;